export default __webpack_public_path__ + "static/media/LightBlue0000.15c86b8b.png";